import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize("G-K5XCENHGD3");
};

export const trackPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};
